const nameFilter = (searchTerm) =>
  searchTerm ? [{ operation: 'icontains', field: 'name', value: searchTerm }] : [];

export const certificationOptionsCallback = {
  httpMethod: 'POST',
  route: 'certifications/read',
  generateBody: (searchTerm) => ({
    filters: [
      { field: 'state.status', operation: 'equals', value: 'active' },
      ...nameFilter(searchTerm),
    ],
  }),
};

export const skillOptionsCallback = {
  httpMethod: 'POST',
  route: 'skills/read',
  generateBody: (searchTerm) => ({
    filters: nameFilter(searchTerm),
  }),
};
